<hr>
<h4>{{'FURTHER_EVENTS'|translate}}</h4>

<div class="form-row" [formGroup]="formGroup">

  <!-- Number items dropdown -->
  <app-form-group formControlName="numberItems" id="dropdownNumberItems" name="numberItems" class="col-4 col-lg-3 mb-1"
    type="dropdown" [selectData]="selectNumberItemsValues" [hideLabels]="hideLabels" text="{{'NUMBER_ITEMS'|translate}}"></app-form-group>

  <!-- Interval dropdown -->
  <app-form-group formControlName="interval" id="dropdownInterval" name="interval" class="col-5 col-lg-3 mb-1" type="dropdown"
    [selectData]="selectIntervalValues" [hideLabels]="hideLabels" text="{{'INTERVAL'|translate}}"></app-form-group>

  <!-- Go button -->
  <div class="col-3 col-lg-3 mb-1">
    <label style="display: block;" *ngIf="!hideLabels">&nbsp;</label>
    <app-button text="{{'GO'|translate}}" (click)="onGoClick()"></app-button>
  </div>

</div>